import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsThisFor() {
  const forYou = ["You're 50+ and your joints punish you for trying to stay active", "You've gained 15-30 lbs and traditional workouts make it worse", 'You want a clear, follow-along plan — not generic fitness advice', "You're willing to train 3 days a week for 30-45 minutes", 'You want to move pain-free AND look better with your shirt off'];
  const notForYou = ["You're looking for a magic pill with zero effort", 'You want to do CrossFit or extreme HIIT', "You're under 40 with no joint issues", "You're not willing to follow a structured plan", 'You expect overnight results without consistency'];
  return <Section background="dark" className="border-t border-slate-900" data-id="element-302">
      <div className="text-center mb-16" data-id="element-303">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase mb-4" data-id="element-304">
          Who Is This <span className="text-brand-orange" data-id="element-305">Blueprint</span> For?
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-306">
          We designed this specifically for a certain type of man. If you fit
          the description on the left, this was built for you.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-307">
        {/* Left Column: FOR YOU */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900 border border-slate-800 border-l-4 border-l-green-500 p-8 rounded-r-xl shadow-lg" data-id="element-308">
          <div className="flex items-center gap-3 mb-8 border-b border-slate-800 pb-4" data-id="element-309">
            <CheckCircle2 className="text-green-500 w-8 h-8" data-id="element-310" />
            <h3 className="text-xl font-heading font-bold text-white uppercase" data-id="element-311">
              This IS For You If...
            </h3>
          </div>

          <ul className="space-y-4" data-id="element-312">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-313">
                <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-314" />
                <span className="text-slate-300" data-id="element-315">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Right Column: NOT FOR YOU */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900 border border-slate-800 border-l-4 border-l-red-500 p-8 rounded-r-xl shadow-lg opacity-80 hover:opacity-100 transition-opacity" data-id="element-316">
          <div className="flex items-center gap-3 mb-8 border-b border-slate-800 pb-4" data-id="element-317">
            <XCircle className="text-red-500 w-8 h-8" data-id="element-318" />
            <h3 className="text-xl font-heading font-bold text-white uppercase" data-id="element-319">
              This Is NOT For You If...
            </h3>
          </div>

          <ul className="space-y-4" data-id="element-320">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-321">
                <XCircle className="text-red-500 w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-322" />
                <span className="text-slate-400" data-id="element-323">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </Section>;
}